if (document !== undefined) {
  // I should also add a condition to check for window as well.
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded loading javascript');
      const floatingButton = document.getElementById('floating-add-to-cart');
      const addToCartButton = document.querySelector('[name="add"]'); // Default button selector
  
      // Function to check if the user is on desktop
      const isDesktop = () => window.innerWidth > 768;
  
      // Show/hide the floating button on scroll
      window.addEventListener('scroll', () => {
          const scrollThreshold = isDesktop() ? 650 : 650; // Show later on desktop, earlier on mobile
          if (window.scrollY > scrollThreshold) {
              floatingButton.style.display = 'flex';
          } else {
              floatingButton.style.display = 'none';
          }
      });
  
      // Mimic the default "Add to Cart" action
      floatingButton.addEventListener('click', () => {
          addToCartButton.click();
      });
  });
}

